import { render, staticRenderFns } from "./SbInvoiceInbounds.vue?vue&type=template&id=93e837a8&"
import script from "./SbInvoiceInbounds.vue?vue&type=script&lang=js&"
export * from "./SbInvoiceInbounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports